export default __webpack_public_path__ + "static/media/Emporium.a7a00d5d.png";